// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y6Wul","content":"styles_content__1HF1p"};